import { __assign } from "tslib";
import * as React from 'react';
import RootBaggageIcon from '@websky/core/src/Baggage/Baggage/components/BaggageIcon/BaggageIcon';
import { useTranslation } from 'react-i18next';
var BaggageIcon = function (props) {
    var t = useTranslation('Checkout').t;
    if (props.baggage.rfics === 'Checked_baggage23_YC_all') {
        var weight = props.baggage.value.amount;
        return (React.createElement(RootBaggageIcon, __assign({}, props, { baggage: __assign(__assign({}, props.baggage), { value: {
                    amount: 2,
                    measurement: t('places up {{weight}}', {
                        weight: "".concat(weight).concat(t(props.baggage.value.measurement))
                    })
                } }) })));
    }
    return React.createElement(RootBaggageIcon, __assign({}, props));
};
export default BaggageIcon;
